import type { QuoteCheckpoint } from "./api";

/**
 * The view's checkpoint ledger as the flow reads it. A server that
 * predates checkpoints answers without the field at all; that reads as an
 * empty ledger, never as a broken view.
 */
export function checkpointsOf(view: {
  checkpoints?: QuoteCheckpoint[] | null;
}): QuoteCheckpoint[] {
  return view.checkpoints ?? [];
}
